var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.342,
    height: 18.345,
    viewBox: "0 0 18.342 18.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_transfer",
    d: "M-9397.335,3629.651a9.105,9.105,0,0,1-6.49-2.68,9.116,9.116,0,0,1-2.68-6.493,9.126,9.126,0,0,1,2.677-6.493,9.119,9.119,0,0,1,6.493-2.68,9.182,9.182,0,0,1,9.172,9.172A9.182,9.182,0,0,1-9397.335,3629.651Zm0-17.013a7.85,7.85,0,0,0-7.841,7.841,7.787,7.787,0,0,0,2.288,5.553,7.8,7.8,0,0,0,5.553,2.29,7.858,7.858,0,0,0,7.843-7.843A7.851,7.851,0,0,0-9397.335,3612.638Zm-1.454,13.167a.659.659,0,0,1-.463-.205l-2.911-2.911a.531.531,0,0,1-.205-.406v-.151a.807.807,0,0,1,.146-.309l.116-.116a.578.578,0,0,1,.345-.144h8.8a.665.665,0,0,1,.666.663.667.667,0,0,1-.666.666h-7.146l1.785,1.79a.636.636,0,0,1,.2.458.659.659,0,0,1-.2.463A.643.643,0,0,1-9398.789,3625.8Zm5.883-6.408h-8.8a.674.674,0,0,1-.665-.666.666.666,0,0,1,.665-.666h7.149l-1.787-1.787a.638.638,0,0,1-.2-.46.664.664,0,0,1,.2-.46.649.649,0,0,1,.463-.2.639.639,0,0,1,.462.2l2.914,2.913a.522.522,0,0,1,.2.4v.151a.806.806,0,0,1-.145.309l-.115.115A.575.575,0,0,1-9392.906,3619.4Z",
    transform: "translate(9406.505 -3611.306)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransfer);
export default __webpack_public_path__ + "static/media/Icon_transfer.14d76654.svg";
export { ForwardRef as ReactComponent };